"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var constants_1 = require("./constants");

var hex_1 = require("./hex");

var keccak_1 = require("./keccak");

function randomAddress() {
  return toChecksumAddress(hex_1.randomHex(20));
}

exports.randomAddress = randomAddress;

function isAddress(value) {
  return hex_1.isHex(value, 'data') && hex_1.getHexBytesSize(value) === 20;
}

exports.isAddress = isAddress;

function toChecksumAddress(address) {
  var result = null;

  if (isAddress(address)) {
    address = address.toLowerCase();
    address = address.slice(2);
    var hash = keccak_1.keccak256(address).slice(2);
    var chars = address.split('').map(function (char, index) {
      return parseInt(hash[index], 16) >= 8 ? char.toUpperCase() : char;
    });
    result = "".concat(constants_1.HEX_PREFIX).concat(chars.join(''));
  }

  return result;
}

exports.toChecksumAddress = toChecksumAddress;

function computeCreate2Address(creator, salt, byteCode) {
  var result = null;

  if (isAddress(creator) && hex_1.isHex(salt, 'data') && hex_1.isHex(byteCode, 'data')) {
    if (hex_1.getHexBytesSize(byteCode) !== 32) {
      byteCode = keccak_1.keccak256(byteCode);
    }

    var payload = hex_1.concatHex('0xff', creator, salt, byteCode);
    var address = "".concat(constants_1.HEX_PREFIX).concat(keccak_1.keccak256(payload).slice(2).slice(-40));
    result = toChecksumAddress(address);
  }

  return result;
}

exports.computeCreate2Address = computeCreate2Address;